export default __webpack_public_path__ + "static/media/3.b4a6ef0e.webp";